var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my"},[(_vm.$route.params.tab == 'orders')?[_c('myOrders')]:(_vm.$route.params.tab == 'profile')?[_c('myProfile')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }